export default __webpack_public_path__ + "static/media/font-icon.115ee486.svg";